<template>
  <div>
    <v-container>
      <v-layout align-center justify-center>
        <v-flex>
          <v-card>
            <v-card-title class="subtitle-1">{{
              $t("labels.CLI_ApplicationSign")
            }}</v-card-title>
          </v-card>
          <v-card class="mt-2">
            <v-card-text>
              <v-row no-gutters>
                <p class="font-weight-regular">
                  {{ $t("labels.CLI_ApplicationGenerated_P1") }}
                </p>
              </v-row>
              <v-row  no-gutters>
                <p class="font-weight-regular">
                  {{ $t("labels.CLI_ApplicationGenerated_P2") }}
                </p>
              </v-row>
              <v-row no-gutters>
                <p class="font-weight-regular">
                  <span>{{
                    $t("labels.CLI_ApplicationGenerated_Sign_P1_V2")
                  }}</span>
                  <v-btn
                    dark
                    x-small
                    color="primary"
                    @click="download"
                    class="ml-1 mr-1"
                    >{{ $t("labels.CLI_Download_V2") }}</v-btn
                  >
                </p>
              </v-row>            
              <v-row  no-gutters>
                <p>{{$t("labels.CLI_EisgnButton")}}</p>              
              </v-row>
              <v-row no-gutters>
                 <p>
                  <v-btn dark x-medium color="primary" @click="file_esign()">{{
                    $t("labels.CLI_ESign")
                  }}</v-btn>                 
                </p>
              </v-row>
            </v-card-text>
          </v-card>
          <form
            ref="dw"
            target="xFrm"
            method="post"
            :action="applicationDownloadURL"
          >
            <input
              type="hidden"
              name="CliApplicationId"
              v-model="applicationDetail.ExistingApplication.CliApplicationId"
            />
            <input type="hidden" name="Token" v-model="token" />
            <input type="hidden" name="SiteId" :value="siteID" />
            <input type="hidden" name="LanguageId" :value="getLanguage()" />
          </form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">E-Sign</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="dialog">
            <v-row dense>
              <!-- <div class="row mt-3 border-top pt-2 mb-2">
                <div class="col-5"><b>Name</b></div>               
                <div class="col-6"><b>Email Address</b></div>
                <div class="col-1"></div>
              </div> -->
              <v-col cols="12" md="3"><b>First Name</b></v-col>
               <v-col cols="12" md="3"><b>Last Name</b></v-col>
              <v-col cols="12" md="5"><b>Email Address</b></v-col>
              <v-col cols="12" md="1"></v-col>
              <Container
                style="width: 100%"
                @drop="onDropEsign"
                drag-class="opacity-ghost"
                drop-class="opacity-ghost-drop"
                drag-handle-selector=".column-drag-handle"
              >
                <Draggable
                  v-for="s in this.signers"
                  :key="s.SignerID"
                  tag="v-row"
                >
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="d-flex align-items-center">
                        <!-- <div class="mr-2">
                          <i
                            v-if="enableOrderFlag"
                            class="fas fa-arrows-alt-v column-drag-handle"
                          ></i>
                        </div> -->
                        <div class="flex-fill">
                          <v-text-field :prepend-icon="enableOrderFlag ? 'fas fa-arrows-alt-v column-drag-handle' : ''" outlined type="text" v-model="s.FirstName"></v-text-field>
                        </div>
                      </div>
                    </v-col>
                     <v-col cols="12" md="3">
                      <v-text-field outlined type="text" v-model="s.LastName" />
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field outlined type="text" v-model="s.Email" />
                    </v-col>
                    <v-col cols="12" md="1">
                      <v-btn
                        @click="eSignRemoveSinger(s)"
                        text
                        
                        color="red"
                        ><v-icon >fas fa-trash-alt</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                </Draggable>
              </Container>
              <v-row>
                <v-col cols="12" md="12"><v-checkbox
                  color="primary"
                  :value="true"
                  :unchecked-value="false"
                  v-model="enableOrderFlag"
                  label="Enable Signing Order"
                /></v-col>
                 <v-col cols="12" md="12">
                  <v-alert
                  v-if="!isESignFormValid || !isESignUniqueEmail"
                  text
                  prominent
                  type="error"
                >
                  <p v-if="!isESignFormValid">{{
                    $t("messages.ESignEnterAllFields")
                  }}</p>
                  <p v-if="!isESignUniqueEmail">{{
                    $t("messages.ESignUniqueEmail")
                  }}</p>
                </v-alert>
                 </v-col>
              </v-row>             
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn dark x-medium color="primary" @click="eSignAddSinger"
            >Add Signer</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn dark x-medium color="primary" @click="dialogClose">{{
            $t("labels.Close")
          }}</v-btn>
          <v-btn :disabled="!isESignFormValid || !isESignUniqueEmail"  x-medium color="primary" @click="postESign">{{
            $t("labels.Next")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog v-model="esignDialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">E-Sign</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="esignDialog">
            <v-row dense>
             <p v-text="$t('messages.ESignDesigner')" />
              <v-btn
                    dark                   
                    color="primary"
                    @click="openEsignInterface"
                    class="ml-1 mr-1"
                    >{{ $t("labels.ESignOpenDesigner") }}</v-btn
                  >                                  
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>         
          <v-spacer></v-spacer>
          <v-btn dark x-medium color="primary" @click="eSigndialogClose">{{
            $t("labels.Close")
          }}</v-btn>         
        </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog v-model="SuccessEsignModal" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('errors.EsignRequestSent')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container >
            <v-row dense>
             <p v-text="$t('messages.EsignSentText')" />                                          
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">         
          <v-btn dark x-medium color="primary" @click="SuccessEsignModalClose">{{
            $t("labels.Close")
          }}</v-btn>         
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>
<script>
import _filter from "lodash/filter";
import _map from "lodash/map";
import _uniq from "lodash/uniq";
import _toUpper from "lodash/toUpper";
import _uniqueId from "lodash/uniqueId";
import localStorageSvc from "@/services/localStorage";
import domainHelper from "@/services/domainHelper";
import dataSvc from "@/services/dataService";
//import uiSvc from "@/services/uiService";
import { Container, Draggable } from "vue-smooth-dnd";
export default {
  components: { Container, Draggable },
  data() {
    return {
      SuccessEsignModal: false,
      loadFlag: false,
      esignDialog: null,
      eSignURL: null,
      enableOrderFlag: false,
      signers: [],
      dialog: false,
      applicationDownloadURL: "",
      siteID: this.$route.params.siteid,
      token: this.$route.params.token,
      loaded: false,
      applicationDetail: {
        Applicants:[],
        ExistingApplication: {
          CliApplicationId: "",
        },
        AgentContactDetail: {
          ContactEmailAddress: "",
        },
      },
      useAgentAccountFlag: true,
      creditConfirmBoxFrm: {
        modalShow: false,
        preAuthorizeFrm: null,
        useAgentAccountFlag: true,

        onOK: null,
        onCancel: null,
      },
    };
  },
  created() {
    this.applicationDownloadURL =
      domainHelper.getAPIHost() + "/ws/downloadcliapplicationWithToken";
    this.loadPage();
  },
  methods: {
    SuccessEsignModalClose(){
      this.SuccessEsignModal=false;
      this.$router.push("/" + this.siteID + "/home");
    },
    openEsignInterface(){
      this.esignDialog = false;
      window.open(this.eSignURL, "_blank");
    },
    onDropEsign(dropResult) {
      this.signers = this.applyDrag(this.signers, dropResult);
    },
    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;

      const result = [...arr];
      let itemToAdd = payload;
      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      return result;
    },
    dialogClose() {
      this.dialog = false;
    },
    eSigndialogClose(){
      this.esignDialog = false;
    },
    eSignRemoveSinger(s) {
      this.signers = _filter(this.signers, (obj) => obj.SignerID != s.SignerID);
    },
    eSignAddSinger() {
      this.signers.push({
        FirstName: "",
        LastName: "",
        Email: "",
        SignerID: _uniqueId("s"),
      });
    },
    loadPage() {
      this.loadFlag = true;
      let postData = {
        siteId: this.siteID,
        token: this.token,
        languageId: this.getLanguage(),
      };

      dataSvc
        .getHttp()
        .post(domainHelper.getAPIHost() + "/cli-api/get-application", postData)
        .then((res) => {
          if (res.data.ReturnStatus.ReturnCode == 200) {
            for (
              let i = 0;
              i < res.data.ApplicationDetails[0].ExistingApplication.ApplicantStatuses.length;
              i++
            ) {
              let e = res.data.ApplicationDetails[0].ExistingApplication.ApplicantStatuses[i];
              this.signers.push({
                Email: e.Email,
                FirstName: e.FirstName,
                LastName: e.LastName,
                SignerID: e.ApplicantId.toString(),
              });
            }
            
            this.loadFlag = false;
            this.applicationDetail = res.data.ApplicationDetails[0];
            console.log(this.applicationDetail);
            // for (
            //   let i = 0;
            //   i < res.data.ApplicationDetails[0].Applicants.length;
            //   i++
            // ) {
            //   let e = res.data.ApplicationDetails[0].Applicants[i];
            //   this.applicationDetail.Applicants.push({
            //     Email: e.Email,
            //     FirstName: e.FirstName,
            //     LastName: e.LastName,
            //     ApplicantId: e.ApplicantId
            //   });
            // }
            // alert("load");
            // console.log(this.applicationDetail);
            this.$refs.dw.reset();
            this.loaded = true;
          } else if (res.data.ReturnStatus.ReturnCode == 403) {
            this.loadFlag = false;
            var applicationListPath =
              "/" + this.siteID + "/cli/application/" + this.token;
            this.$router.push({ path: applicationListPath });
          } else {
            this.loadFlag = false;
            this.errorMessage = this.$t(
              "errors." + res.data.ReturnStatus.ReturnMessage
            );
            this.showErrorAlert = true;
          }
        })
        .catch((err) => {
          this.loadFlag = false;
          //   uiSvc.ge(err);
        });
    },
    getLanguage() {
      return localStorageSvc.getLanID();
    },
    download() {
      this.$refs.dw.submit();
    },
    file_esign() {
      this.postESign();
      return;
      //window.close('','_parent','');
       //this.dialog = true;
    //   return;
      let postData = {
        siteId: this.siteID,
        token: this.token,
        languageId: this.getLanguage(),
        FeatureCreditTransactionTypeDD: 5,
        FK1: this.applicationDetail.MortgageApplicationId,
        FK2: this.applicationDetail.Applicants[0].ApplicantId,
        FK3: "",
      };

      dataSvc
        .getHttp()
        .post(domainHelper.getAPIHost() + "/cli-api/CLI-PreAuthorize", postData)
        .then((res) => {
          if (res.data.ReturnStatus.ReturnCode == 200) {
            
            if (res.data.PointAmount == -1) {
              //this.dialog = true;
               this.postESign();
              return;
            } else {              
              if (res.data.InsufficientFundsFlag) {
                this.loadFlag = false;                  
                this.$alert(
                  this.$t("Warning"),
                  this.$t("errors.FeatureCreditInsufficientCredits")
                );
                return;
              } else {
                this.loadFlag = false;
                this.$confirm(
                  this.$t("labels.Warning"),
                  this.$t("messages.DisclaimerPoints"),
                  () => {                     
                      //this.dialog = true;
                    this.postESign();
                    return;
                  },
                  () => {}
                );
              }
            }
          } else {
            this.loadFlag = false;
            this.$alert(
              this.$t("Warning"),
              this.$t("errors.FeatureCreditInsufficientCredits")
            );
            return;
          }
        })
        .catch((err) => {
          this.loadFlag = false;
          uiSvc.alertError(err);
        });
    },

    postESign() {      
      let postData = {
        Signers: this.signers,
        MortgageApplicationID: this.applicationDetail.MortgageApplicationId,      
        siteId: this.siteID,
        token: this.token,
        languageId: this.getLanguage(),
        EnableOrdering: this.enableOrderFlag,
        CliApplicationId: this.applicationDetail.ExistingApplication.CliApplicationId        
      };       
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post(domainHelper.getAPIHost() + "/cli-api/CreateDocuSignLink", postData).then(res => {
          this.loadFlag=false;         
          if(res.data.ReturnStatus.ReturnCode == 200){
            this.dialog=false;
            //this.esignDialog=true;
            //this.eSignURL = res.data.ESignUrl;       
            // this.$alert(
            //   this.$t("Success"),
            //   this.$t("errors.EsignRequestSent")
            // );     
            this.SuccessEsignModal = true;
            
    }else{
      if (res.data.ReturnStatus.ReturnMessage == "INSUFFICIENT_FUNDS") {
             this.$alert(
              this.$t("Warning"),
              this.$t("errors.CLIFeatureCreditInsufficientCredits")
            );
            return;   
        }
    }
        });
   
    },
  },
  computed: {
     ProductionFlag() {
      return process.env.VUE_APP_IsDebug == "false";
    },
    isESignFormValid() {
      if (this.signers.length == 0) return false;
      for (let i = 0; i < this.signers.length; i++) {
        if (!this.signers[i].Email) return false;
        if (!this.signers[i].FirstName) return false;
        if (!this.signers[i].LastName) return false;
      }
      return true;
    },
    isESignUniqueEmail() {
      if (this.signers.length == 0) return true;
      let emails = _uniq(_map(_map(this.signers, "Email"), _toUpper));
      if (emails.length != this.signers.length) return false;
      return true;
    },
  },
};
</script>
<style scoped>
</style>